var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isSoshShop
    ? _c("sosh-mobile-recovery", {
        attrs: {
          "recovery-amount-in-cents": _vm.recoveryAmountInCents,
          "recovery-device-model": _vm.recoveryDeviceModel,
          "manual-estimation": _vm.manualEstimation,
          "bonus-amount-in-cents": _vm.bonusAmountInCents,
          "simulator-modal-id": _vm.simulatorModalId,
          "recovery-modal-id": _vm.recoveryModalId,
          "bonus-recovery-selector-link": _vm.bonusRecoverySelectorLink,
          "bonus-recovery-selector-link-label":
            _vm.bonusRecoverySelectorLinkLabel,
          messages: _vm.messages,
          "desktop-visual": _vm.visual.soshDesktopSrc,
          "mobile-visual": _vm.visual.soshMobileSrc,
        },
      })
    : _c("orange-mobile-recovery", {
        attrs: {
          "recovery-amount-in-cents": _vm.recoveryAmountInCents,
          "recovery-device-model": _vm.recoveryDeviceModel,
          "manual-estimation": _vm.manualEstimation,
          "bonus-amount-in-cents": _vm.bonusAmountInCents,
          "simulator-modal-id": _vm.simulatorModalId,
          "recovery-modal-id": _vm.recoveryModalId,
          "bonus-recovery-selector-link": _vm.bonusRecoverySelectorLink,
          "bonus-recovery-selector-link-label":
            _vm.bonusRecoverySelectorLinkLabel,
          messages: _vm.messages,
          "device-visual": _vm.visual.orangeDeviceSrc,
          "wallpaper-desktop-visual": _vm.visual.orangeDesktopWallpaperSrc,
          "wallpaper-mobile-visual": _vm.visual.orangeMobileWallpaperSrc,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }